import { useStaticQuery, graphql } from "gatsby"

const useShowcaseQuery = () => {
  const { buy, sold, lease } = useStaticQuery(graphql`
    query ShowcaseQuery {
      buy: allWpProperty(
        filter: {propertyListing: {status: {in: ["Available", "Conditional"]}, hiddenListing: {eq: false}, offMarketListing: {eq: false}, listedDate: {ne: ""}, searchPrice: {gt: 3500000}}, propertyData: {type: {in: ["Residential", "Rural"]}}}
        sort: {propertyListing: {listedDate: DESC}}
        limit: 3
      )
      {
        nodes {
          ...PropertyCard
        }
      }
      sold: allWpProperty(
        filter:{
          propertyListing: {
            status: {in: ["Settled", "Unconditional"]},
            hiddenListing: {eq: false},
            soldDate: {ne: ""},
            offMarketListing: {eq: false}
            searchPrice: {gt: 3500000}
          }
          propertyData: {type: {eq: "Residential"}}
        }
        sort: {propertyListing: {soldDate: DESC}}
        limit: 3
      )
      {
        nodes {
          ...PropertyCard
        }
      }
      lease: allWpRental(
        filter:{
          propertyListing :{ status:{in:["Available", "Conditional"]}, hiddenListing: {eq: false}, searchPrice: {gt: 1000}}
          propertyData: {type: {eq: "Residential"}}
        }
        sort: {propertyListing: {listedDate: DESC}}
        limit: 3
      )
      {
        nodes {
          ...RentalCard
        }
      }
    }
  `)
  return { buy: [...buy.nodes], sold: [...sold.nodes], lease: [...lease.nodes]} || {}
}

export default useShowcaseQuery